var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 37,
    viewBox: "0 0 109 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.709 7.0935H98.9566V0.439697H88.5206L83.7213 7.0935H75.1931L72.3415 9.94512V7.0935H65.6877V0.439697H44.7757V7.0935H15.3564L10.5562 0.439697H0.10022V23.2527L13.4078 36.5603H26.7154V32.7581L30.5176 36.5603H56.1822V32.7581L59.9844 36.5603H72.3415V32.7581L76.1436 36.5603H99.9072L108.462 28.0054V11.8462L103.709 7.0935ZM16.2594 16.5989H9.60565V18.5H16.2594V26.1043H5.80348L2.0013 22.3022V2.34078H9.60565V8.99458H16.2594V16.5989ZM44.7757 26.1043H21.9627L18.1605 22.3022V8.99458H25.7649V18.5H27.666V8.99458H35.2703V18.5H37.1714V8.99458H44.7757V26.1043ZM54.2811 26.1043H46.6768V8.99458H54.2811V26.1043ZM54.2811 7.0935H46.6768V2.34078H54.2811V7.0935ZM70.4404 16.5989H63.7866V18.5H70.4404V26.1043H59.9844L56.1822 22.3022V2.34078H63.7866V8.99458H70.4404V16.5989ZM87.5501 16.5989H79.9458V18.5H87.5501V26.1043H76.1436L72.3415 22.3022V12.7968L76.1436 8.99458H87.5501V16.5989ZM106.561 26.1043H98.9566V16.5989H97.0556V26.1043H89.4512V2.34078H97.0556V8.99458H102.759L106.561 12.7968V26.1043Z",
    fill: "#1D244A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.965a323c7236d721594ad36549b8d63b.svg";
export { ForwardRef as ReactComponent };